import { createContext, useContext } from 'react';

export type TransitionContextType = {
  startTransition: (path: string, fadeDurationMs?: number) => Promise<void>;
  isTransitioning: boolean;
};

export const TransitionContext = createContext<TransitionContextType | null>(
  null,
);

export const useRouteTransition = (): TransitionContextType => {
  const ctx = useContext(TransitionContext);
  if (!ctx) {
    throw new Error(
      'useRouteTransition must be used within TransitionProvider',
    );
  }
  return ctx;
};

